import { FC } from 'react';
import { Link } from '@/i18n/navigation';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import s from './Footer.module.css';
import { FooterProps } from '@/types/model';
import { ImageLoader } from '@/lib/imageLoader';
import { useTranslations } from 'next-intl';

const Footer: FC<FooterProps> = ({ icon, direction, phones, social, disclaimer }) => {
  const year = new Date().getFullYear();
  const t = useTranslations('footer');

  return (
    <footer className={s.container}>
      <div className={s.container__flex_top}>
        <div className={s.container__marevera}>
          <div className={s.container__marevera__icon}>
            <ReactSVG src={ImageLoader({ src: icon?.url })} beforeInjection={hideDecorativeSvg} />
          </div>
          <p className={s.container__marevera__adress}>{direction}</p>
        </div>
        <div className={s.container__contact}>
          <div>
            {phones[0] && (
              <div className={s.container__contact__item} key={phones[0].id}>
                <ReactSVG
                  src={ImageLoader({ src: phones[0].icon?.url })}
                  beforeInjection={hideDecorativeSvg}
                />
                <a
                  href={`tel:+${phones[0].phoneNumber}`}
                  aria-label={`${t('contactPhone')} ${phones[0].phoneNumber}`}>
                  {phones[0].phoneNumber}
                </a>
              </div>
            )}
            {phones[1] && (
              <div className={s.container__contact__item} key={phones[1].id}>
                <ReactSVG
                  src={ImageLoader({ src: phones[1].icon?.url })}
                  beforeInjection={hideDecorativeSvg}
                />
                <a
                  href={`https://wa.me/52${phones[1].phoneNumber.replace(/\s/g, '')}`}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`${t('contactWhatsApp')} ${phones[1].phoneNumber}`}>
                  {phones[1].phoneNumber}
                </a>
              </div>
            )}
          </div>
          <div>
            {social.map((item) => (
              <div className={s.container__contact__item} key={item.id}>
                <ReactSVG
                  src={ImageLoader({ src: item.icon?.url })}
                  beforeInjection={hideDecorativeSvg}
                />
                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={t('openSocial', { name: item.name })}>
                  {item.name}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className={s.container__legal}>{disclaimer}</p>

      <div className={s.container__flex}>
        <div className={s.container__nav}>
          <p>Copyright © {year}</p>
          <Link href="/aviso-de-privacidad">{t('privacy')}</Link>
        </div>
        <Link
          href="https://metros2digital.com/"
          className={s.container__logotipo}
          target="_blank"
          rel="noreferrer"
          aria-label={`${t('developedBy')} M2Digital`}>
          <p>{t('developedBy')}</p>
          <div className={s.container__logotipo__m2d}>
            <ReactSVG src="/icons/M2Digital.svg" beforeInjection={hideDecorativeSvg} />
          </div>
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
